import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgCompass = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m14.641-4.641a.75.75 0 0 1 .153.84l-2.57 5.653a.75.75 0 0 1-.372.372l-5.653 2.57a.75.75 0 0 1-.993-.993l2.57-5.653a.75.75 0 0 1 .372-.372l5.653-2.57a.75.75 0 0 1 .84.153m-5.616 3.666L9.399 14.6l3.576-1.626L14.601 9.4z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgCompass;
